export default __webpack_public_path__ + "static/media/Groupe 9099.7d3a12d2.svg";